module.exports = __webpack_public_path__ + "static/media/delete.94b55b3a.svg";